import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { coro } from '../configuration/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    icons: {
      iconfont: 'md',
    },
    themes: {
      light: {
        primary: coro['primary-500'],
        secondary: coro.gray,
        accent: '#8c9eff',
        error: '#b71c1c',
        background: coro.lightgray,
      },
    },
  },
})
